<div class='auditLineContainer'>
  Created at {{ formatDate(data.createdAt) }} by {{ this.username }}. Last Updated at {{ formatDate(data.updatedAt) }}<br /><br />
</div>
